import Vue from 'vue';

// 容器内元素自动弹性排序（ResizeObser的兼容性、节流）暂时没有使用
export default Vue.directive('flex', function(el, binding){
    const { value } = binding;
    const { selector, minWidth, minMargin, minCol } = value;
    const cards = (el.querySelectorAll(selector));

    const ro = new (window && (window as any).ResizeObserver)(entries => {
        for (let entry of entries) {
            const cr = entry.contentRect;
            const { width } = cr;
            const realCardW = cards[0] && cards[0].offsetWidth || 0;
            const cardW = realCardW + 2 * minMargin;
            const containerW = width || 0;
            if (containerW > cardW * minCol) {
                // 自适应
                const leftW = containerW - cardW * minCol;
                const allCardNum = parseInt('' + (containerW / cardW), 10);
                const allMargin = leftW % cardW;
                let perMargin = parseInt('' + (allMargin / allCardNum / 2), 10);
                perMargin = perMargin > 0 ? perMargin : 0;
                cards.forEach(card => {
                    card.style.marginLeft = card.style.marginRight = `${minMargin + perMargin}px`
                });
            } else {
                cards.forEach(card => {
                    card.style.marginLeft = card.style.marginRight = `${minMargin}px`
                });
            }
        }
    });

    ro.observe(el);
});
